/**
 * Deliberately compact scale vs. MUI's own consumer-web default —
 * this app packs dense data grids and forms (like every real EMR
 * competitor); MUI's default `h1`/`body1` sizes are tuned for
 * marketing pages, not a table-and-form-dense desktop app.
 *
 * ONE TYPEFACE, AND WHY THIS LINE WAS WRONG FOR A LONG TIME.
 *
 * This declared `"Inter", "Roboto", …` and NEITHER FACE IS LOADED. There is no
 * `@font-face` for either one and no stylesheet fetches them; `public/fonts`
 * holds Plus Jakarta Sans and JetBrains Mono, nothing else. `design-tokens.css`
 * already recorded the same discovery for the Tailwind half of the app and
 * fixed it there — but MUI's `CssBaseline` writes `theme.typography.fontFamily`
 * onto `body`, and every `<Typography>` restates it, so this string beat the
 * `html` rule on all 484 files built with MUI.
 *
 * The product was therefore rendering in TWO faces at once: Jakarta on the
 * Tailwind screens the client approved, and whatever the workstation's OS
 * supplies on every MUI screen beside them. That is the mechanical cause of
 * "the modules don't feel like one application" — two adjacent screens were
 * genuinely set in different type.
 *
 * Stating the loaded face here is the whole fix. The FALLBACKS are real system
 * stacks rather than two more unloaded names, so a font that fails to fetch
 * degrades to something chosen instead of to a serif.
 */
import type { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: TypographyVariantsOptions = {
  fontFamily: "'Jakarta', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  h1: { fontSize: '2rem', fontWeight: 600, lineHeight: 1.3 },
  h2: { fontSize: '1.625rem', fontWeight: 600, lineHeight: 1.3 },
  h3: { fontSize: '1.375rem', fontWeight: 600, lineHeight: 1.35 },
  h4: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.4 },
  h5: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.4 },
  h6: { fontSize: '0.875rem', fontWeight: 600, lineHeight: 1.4 },
  subtitle1: { fontSize: '0.9375rem', fontWeight: 500 },
  subtitle2: { fontSize: '0.8125rem', fontWeight: 500 },
  body1: { fontSize: '0.875rem', lineHeight: 1.5 },
  body2: { fontSize: '0.8125rem', lineHeight: 1.5 },
  button: { fontSize: '0.8125rem', fontWeight: 600, textTransform: 'none' },
  caption: { fontSize: '0.75rem' },
  overline: { fontSize: '0.6875rem', fontWeight: 600, letterSpacing: '0.06em' },
};
